import { useEffect, useState } from 'react';

export const usePersistentLines = ({ storageKey, navigationState }) => {
  const [lines, setLines] = useState([]);

  useEffect(() => {
    if (!storageKey) {
      setLines([]);
      return;
    }

    if (Array.isArray(navigationState?.lines)) {
      setLines(navigationState.lines);
      sessionStorage.setItem(storageKey, JSON.stringify(navigationState.lines));
      return;
    }

    const persistedLines = sessionStorage.getItem(storageKey);
    if (!persistedLines) {
      setLines([]);
      return;
    }

    try {
      const parsedLines = JSON.parse(persistedLines);
      setLines(Array.isArray(parsedLines) ? parsedLines : []);
    } catch {
      setLines([]);
      sessionStorage.removeItem(storageKey);
    }
  }, [storageKey, navigationState]);

  useEffect(() => {
    if (!storageKey) {
      return;
    }

    sessionStorage.setItem(storageKey, JSON.stringify(lines));
  }, [lines, storageKey]);

  return {
    lines,
    setLines,
  };
};
